import { GetInferredFromRaw } from '@thinknimble/tn-models'
import { z } from 'zod'

/** Read shape for listing/retrieving bot tokens. Never includes the raw secret. */
export const botTokenShape = {
  id: z.string().uuid(),
  name: z.string(),
  prefix: z.string(),
  botUserId: z.string().uuid(),
  organization: z.string().uuid(),
  permissions: z.array(z.string()),
  lastUsedAt: z.string().datetime().nullable(),
  createdBy: z.string().uuid().nullable(),
  created: z.string().datetime(),
  /** OAuth client name when this bot is an MCP connection (e.g. "Claude"), else null. */
  connectionClientName: z.string().nullable().optional(),
}

/** Input shape for minting a bot token. */
export const createBotTokenShape = {
  name: z.string(),
  organization: z.string().uuid(),
  permissions: z.array(z.string()),
}

/**
 * Response shape for a freshly minted bot token. The raw `token` secret is
 * only ever returned once, at creation time.
 */
export const botTokenCreatedShape = {
  id: z.string().uuid(),
  name: z.string(),
  token: z.string(),
  botUserId: z.string().uuid(),
  organization: z.string().uuid(),
  permissions: z.array(z.string()),
  created: z.string().datetime(),
}

export const botTokenFilterShape = {
  organization: z.string().uuid(),
}

export type BotToken = GetInferredFromRaw<typeof botTokenShape>
export type CreateBotToken = GetInferredFromRaw<typeof createBotTokenShape>
export type BotTokenCreated = GetInferredFromRaw<typeof botTokenCreatedShape>
export type BotTokenFilter = GetInferredFromRaw<typeof botTokenFilterShape>
